import {l} from "types/typescriptdefinisjoner_lederplan";
import moment from "moment";
import _ from "lodash";

/** Hjelpemetoder som operer på DatoPeriod */
export class DatoPerioder {

    static inneholder(periode:l.DatoPeriode, dato:Date) {
        const _dato = moment(dato);
        if (_dato.isBefore(periode.start)) return false;
        if (DatoPerioder.harÅpenSlutt(periode)) return true;
        return _dato.isSameOrBefore(periode.slutt);
    }

    static inneholderNå(periode:l.DatoPeriode) {
        return DatoPerioder.inneholder(periode, new Date());
    }

    static inneholderIkkeNå(periode:l.DatoPeriode) {
        return !DatoPerioder.inneholderNå(periode);
    }

    /** Sann dersom angitt periode har åpen slutt.
     * På java-siden er åpen slutt representert med datokonstanten no.systemfabrikken.lederplan.delt.Dato.maxZonedDateTime (33658-09-27T01:46:40Z),
     * men da ulike nettlesere har vist tegn til ulike toleranse for store datoer representeres 'åpen slutt' som slutt=null i json,
     * se no.systemfabrikken.lederplan.infrastruktur.datatyper.DatoPeriode.sluttSomOptional */
    static harÅpenSlutt (periode:l.DatoPeriode) {
        return _.isNil(periode.slutt);
    }

    static harIkkeÅpenSlutt (periode:l.DatoPeriode) {
        return !DatoPerioder.harÅpenSlutt(periode);
    }

    static overlapper(a: l.DatoPeriode, b: l.DatoPeriode) {
        if (DatoPerioder.inneholder(a, b.start)) return true;
        if (DatoPerioder.inneholder(a, b.slutt)) return true;

        if (DatoPerioder.inneholder(b, a.start)) return true;
        if (DatoPerioder.inneholder(b, a.slutt)) return true;
        return false;
    }

    static slutterFør(periode: l.DatoPeriode, dato: Date): boolean {
        if (_.isNil(periode)) return false;
        if (DatoPerioder.harÅpenSlutt(periode)) return false    ;
        return periode.slutt.getTime() < dato.getTime();
    }

    static starterEtter(periode: l.DatoPeriode, dato: Date): boolean {
        if (_.isNil(periode)) return false;
        return periode.start.getTime() > dato.getTime();
    }

    static erPassert(periode: l.DatoPeriode) {
        return DatoPerioder.slutterFør(periode, new Date());
    }

    static kopier(periode: l.DatoPeriode):l.DatoPeriode{
        if (_.isNil(periode)) return periode;
        return {start: periode.start, slutt:periode.slutt};
    }
}
